// Archivo: TableInfo.js

import { Table, TableCaption, TableContainer, Tbody, Td, Th, Thead, Tr, Skeleton } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";
import queryEnv from "constants/queryConst";
import environment from "constants/apiConst";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

export const TableInfo = () => {
  const location = useLocation();
  const { id = null } = queryString.parse(location.search);
  const { requestData } = useGlobalContext(); // Tu hook para hacer peticiones

  // Usamos useQuery para suscribirnos a los datos
  const { data: response, isLoading } = useQuery({
    queryKey: [queryEnv?.INTEGRATION_BOX, id], // La clave de la query
    queryFn: () => // La función que obtiene los datos
      requestData({
        Endpoint: environment.SHOW_INTEGRACION_BOX_ID,
        data: { id },
        PropertyBody: "POST",
      }),
    enabled: !!id, // Solo ejecuta la query si el 'id' existe
  });

  // Extraemos los datos del objeto de respuesta para mayor claridad
  const tableData = response?.data?.status?.data;

  // Mostramos un esqueleto de carga mientras se obtienen los datos
  if (isLoading) {
    return (
      <TableContainer border={"1px solid #E0E0E0"} borderRadius={10}>
        <Table>
          <Thead>
            <Tr>
              <Th borderRight={"1px solid #E0E0E0"}></Th>
              <Th isNumeric>Peso en kilos</Th>
              <Th isNumeric>Total en US$</Th>
            </Tr>
          </Thead>
          <Tbody>
            {[...Array(6)].map((_, i) => (
              <Tr key={i}>
                <Td><Skeleton height="20px" /></Td>
                <Td><Skeleton height="20px" /></Td>
                <Td><Skeleton height="20px" /></Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <TableContainer border={"1px solid #E0E0E0"} borderRadius={10}>
      <Table>
        <Thead>
          <Tr>
            <Th borderRight={"1px solid #E0E0E0"}></Th>
            <Th isNumeric>Peso en kilos</Th>
            <Th isNumeric>Total en US$</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}>Materia e Insumos</Td>
            <Td isNumeric>{tableData?.total_supply_net_weight_new}</Td>
            <Td isNumeric>{tableData?.total_supply_fob_new}</Td>
          </Tr>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}>Otros costos</Td>
            <Td isNumeric>{tableData?.total_other_net_weight}</Td>
            <Td isNumeric>{tableData?.total_other_fob}</Td>
          </Tr>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}></Td>
            <Td isNumeric></Td>
            <Td isNumeric></Td>
          </Tr>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}>Total calculado</Td>
            <Td isNumeric>{tableData?.total_net_weight_new}</Td>
            <Td isNumeric>{tableData?.total_fob_value_new}</Td>
          </Tr>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}>Total producto</Td>
            <Td isNumeric>{tableData?.total_product_net_weight}</Td>
            <Td isNumeric>{tableData?.total_product_fob}</Td>
          </Tr>
          <Tr>
            <Td borderRight={"1px solid #E0E0E0"}>Diferencia</Td>
            <Td isNumeric>{tableData?.total_net_weight_difference_new}</Td>
            <Td isNumeric>{tableData?.total_fob_value_difference_new}</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};